import React from "react";
import { Sun, Moon, Sparkles, CalendarDays, List as ListIcon, Settings as SettingsIcon } from "lucide-react";

// Top action bar: greeting + four circular buttons (theme / stats / view / settings).
// All logic stays in App; this component is presentational.
export function Header({
    avatarName,
    theme, onToggleTheme,
    onOpenStats,
    viewMode, onToggleView,
    onOpenSettings,
}) {
    return (
        <div className="flex items-center justify-between mb-2 gap-2">
            <div className="min-w-0 flex-1">
                <p className="font-display text-[10px] sm:text-xs uppercase tracking-widest text-warm-500 truncate" data-testid="header-date">
                    {new Date().toLocaleDateString(undefined, { weekday: "long", month: "long", day: "numeric" })}
                </p>
                <h1 className="font-display text-2xl sm:text-3xl text-warm-900 truncate">
                    Hi, I'm {avatarName || "Mochi"}
                </h1>
            </div>
            <div className="flex items-center gap-2 shrink-0">
                <button
                    onClick={onToggleTheme}
                    className="w-11 h-11 rounded-full bg-surface hover:bg-surface-hover flex items-center justify-center text-warm-800 transition-all shadow-clay"
                    data-testid="theme-toggle-btn"
                    aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
                    title={theme === "dark" ? "Light mode" : "Dark mode"}
                >
                    {theme === "dark" ? <Sun size={18} /> : <Moon size={18} />}
                </button>
                <button
                    onClick={onOpenStats}
                    className="w-11 h-11 rounded-full bg-surface hover:bg-surface-hover flex items-center justify-center text-warm-800 transition-all shadow-clay"
                    data-testid="stats-open-btn"
                    aria-label="Your week"
                    title="Your week"
                >
                    <Sparkles size={18} />
                </button>
                <button
                    onClick={onToggleView}
                    className="w-11 h-11 rounded-full bg-surface hover:bg-surface-hover flex items-center justify-center text-warm-800 transition-all shadow-clay"
                    data-testid="view-toggle-btn"
                    aria-label={viewMode === "list" ? "Switch to calendar view" : "Switch to list view"}
                    title={viewMode === "list" ? "Calendar view" : "List view"}
                >
                    {viewMode === "list" ? <CalendarDays size={18} /> : <ListIcon size={18} />}
                </button>
                <button
                    onClick={onOpenSettings}
                    className="w-11 h-11 rounded-full bg-surface hover:bg-surface-hover flex items-center justify-center text-warm-800 transition-all shadow-clay"
                    data-testid="settings-open-btn"
                    aria-label="Settings"
                >
                    <SettingsIcon size={18} />
                </button>
            </div>
        </div>
    );
}

export default Header;
